import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("cg_theme") || "dark");
  const [brand, setBrand] = useState(null);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("cg_theme", theme);
  }, [theme]);

  const loadBrand = useCallback(async () => {
    try {
      const { data } = await api.get("/config/brand");
      setBrand(data.brand);
      if (data.brand?.product_name) document.title = data.brand.product_name;
      if (data.brand?.favicon) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
        link.href = data.brand.favicon;
      }
    } catch { /* keep defaults */ }
  }, []);

  useEffect(() => { loadBrand(); }, [loadBrand]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <SettingsContext.Provider value={{ theme, toggleTheme, brand, reloadBrand: loadBrand }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext) || { theme: "dark", toggleTheme: () => {}, brand: null, reloadBrand: () => {} };
